module.exports = "/_next/static/images/gg-218797b33aacbc8cfe0ea3ee919fcbb8.svg";